/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscordRelayMessageUpdateMessage
 */
export interface DiscordRelayMessageUpdateMessage {
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayMessageUpdateMessage
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayMessageUpdateMessage
     */
    channelId: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayMessageUpdateMessage
     */
    guildId: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayMessageUpdateMessage
     */
    content: string;
    /**
     * 
     * @type {Date}
     * @memberof DiscordRelayMessageUpdateMessage
     */
    timestamp: Date;
    /**
     * 
     * @type {Date}
     * @memberof DiscordRelayMessageUpdateMessage
     */
    editedTimestamp: Date;
    /**
     * 
     * @type {object}
     * @memberof DiscordRelayMessageUpdateMessage
     */
    author: object;
}

export function DiscordRelayMessageUpdateMessageFromJSON(json: any): DiscordRelayMessageUpdateMessage {
    return DiscordRelayMessageUpdateMessageFromJSONTyped(json, false);
}

export function DiscordRelayMessageUpdateMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordRelayMessageUpdateMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'channelId': json['channelId'],
        'guildId': json['guildId'],
        'content': json['content'],
        'timestamp': (new Date(json['timestamp'])),
        'editedTimestamp': (new Date(json['editedTimestamp'])),
        'author': json['author'],
    };
}

export function DiscordRelayMessageUpdateMessageToJSON(value?: DiscordRelayMessageUpdateMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'channelId': value.channelId,
        'guildId': value.guildId,
        'content': value.content,
        'timestamp': (value.timestamp.toISOString()),
        'editedTimestamp': (value.editedTimestamp.toISOString()),
        'author': value.author,
    };
}


